import { render, staticRenderFns } from "./TotalEquipaments.vue?vue&type=template&id=b1b1edb6&scoped=true&"
import script from "./TotalEquipaments.vue?vue&type=script&lang=js&"
export * from "./TotalEquipaments.vue?vue&type=script&lang=js&"
import style0 from "./TotalEquipaments.vue?vue&type=style&index=0&id=b1b1edb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1b1edb6",
  null
  
)

export default component.exports